import styled from 'styled-components';

/**
 * Utility component for styling copier survey text.
 * Survey is copied by using textContent which doesn't care about css
 */
export const CopiedTextOnly = styled.span`
  display: none;
`;
